/* Mega Menu — WAAPI animation (CLICK-ONLY) */
(() => {
  const DURATION = 350;
  const EASING = 'cubic-bezier(.2,.7,.3,1)';

  function closeSiblingMegaMenus(current) {
    document.querySelectorAll('details.mega-menu[open]').forEach((d) => {
      if (d !== current) d.__api?.close({ force: true });
    });
  }

  function bindMegaMenus(root = document) {
    root.querySelectorAll('details.mega-menu').forEach((details) => {
      if (details.__megaBound) return;
      details.__megaBound = true;

      const summary = details.querySelector('summary');
      const panel = details.querySelector('.mega-menu__content');
      if (!summary || !panel) return;

      let anim = null;
      let openState = details.hasAttribute('open');

      // Initial state
      if (openState) {
        panel.style.opacity = '1';
        panel.style.transform = 'translateY(0)';
        panel.style.pointerEvents = 'auto';
        panel.removeAttribute('hidden');
      } else {
        panel.style.opacity = '0';
        panel.style.transform = 'translateY(-16px)';
        panel.style.pointerEvents = 'none';
        panel.setAttribute('hidden', '');
      }

      const kill = () => { if (anim) { anim.cancel(); anim = null; } };

      function show() {
        if (openState) return;
        closeSiblingMegaMenus(details);
        kill();
        panel.removeAttribute('hidden');
        details.setAttribute('open', '');
        panel.style.pointerEvents = 'auto';
        anim = panel.animate(
          [{ opacity: 0, transform: 'translateY(-16px)' },
           { opacity: 1, transform: 'translateY(0)' }],
          { duration: DURATION, easing: EASING, fill: 'forwards' }
        );
        anim.onfinish = anim.oncancel = () => { anim = null; };
        openState = true;
      }

      function hide({ force = false } = {}) {
        if (!openState && !force) return;
        kill();
        anim = panel.animate(
          [{ opacity: 1, transform: 'translateY(0)' },
           { opacity: 0, transform: 'translateY(-16px)' }],
          { duration: DURATION, easing: EASING, fill: 'forwards' }
        );
        const finish = () => {
          details.removeAttribute('open');
          panel.setAttribute('hidden', '');
          panel.style.pointerEvents = 'none';
          anim = null; openState = false;
        };
        anim.onfinish = anim.oncancel = finish;
        setTimeout(() => { if (anim) { try { anim.finish(); } catch {} } }, DURATION + 50);
      }

      details.__api = { open: show, close: hide };

      // CLICK-ONLY toggle
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openState ? hide() : show();
      });

      // ESC to close
      details.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && openState) { hide(); summary.focus(); }
      });

      // Click outside to close
      document.addEventListener('click', (evt) => {
        if (openState && !details.contains(evt.target)) hide();
      });

      // Keep in sync if other code toggles [open]
      details.addEventListener('toggle', () => {
        if (details.open && !openState) { details.removeAttribute('open'); show(); }
        if (!details.open && openState) { details.setAttribute('open', ''); hide(); }
      });
    });
  }

  // INIT
  const init = (root) => { bindMegaMenus(root); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
